import React, {FC, useEffect, useState} from "react";
import {Col, Form, Input, Modal, notification, Row, Upload} from "antd";
import Button from "mixins/ui/button/button";
import {UploadProps} from "antd/lib/upload/interface";
import AttachFileIcon from 'icons/attach-file.svg'
import {getExt, localize} from "mixins/helpers";

const AddFileModal: FC = (props: any) => {
    const [form] = Form.useForm();
    const [attachments, setAttachments] = useState<any[]>([]);

    const fileProps: UploadProps = {
        beforeUpload: file => {
            setAttachments([file]);

            return false;
        },
        onRemove: (file) => {
            setAttachments(attachments.filter(x => x.uid !== file.uid));
        },
        fileList: attachments
    };

    const close = () => {
        form.resetFields();
        setAttachments([]);
        props.handleCancel();
    };

    const save = () => {
        if (attachments.length > 0) {
            const name = form.getFieldValue('name');
            const [file] = attachments;
            file.displayName = name;

            const isLt15M = file.size / 1024 / 1024 < 20;
            if (isLt15M) {
                if (file.name && ['pdf','txt','doc','docx','xls','xlsx','jpeg','png','jpg'].includes(getExt(file.name))) {
                    if (props.file) {
                        if (props.file.name !== file.name || props.getFileDesc(props.file.name, false) !== name) {
                            const index = props.attachments.map(x => x.name).indexOf(props.file.name);
                            props.attachments[index] = file;
                            props.setAttachments([...props.attachments]);
                        }
                    } else {
                        props.setAttachments([...props.attachments, file]);
                    }

                    props.uploadFile(file, name, !!props.file);

                    close();
                } else {
                    notification['error']({
                        message: `Не корректный формат файла! Допустимые форматы - pdf,txt,doc,docx,xls,xlsx,jpeg,png,jpg`
                    });
                }
            } else {
                notification['warning']({
                    message: localize('stats-external-maximum-mb', props.translations),
                });
            }
        } else {
            notification['error']({
                message: `Файл не выбран!`
            });
        }
    };

    useEffect(() => {
        if (props.file) {
            form.setFieldValue('name', props.getFileDesc(props.file.name, false));
            setAttachments([props.file]);
        }
    }, [props.file]);

    return (
        <Modal title="Прикрепить файл"
               open={props.isModalOpen}
               onCancel={close}
               width="85%"
               footer={null}
        >
            <Form form={form} onFinish={save} layout="vertical">
                <Row gutter={[15, 15]} >
                    <Col span={24}>
                        <Form.Item
                            label="Описание"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: localize(
                                        'error.field-is-required',
                                        props.translations
                                    ),
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Upload {...fileProps} maxCount={1}>
                            <Button className="admin-create-page__form-upload" icon={<AttachFileIcon />}>
                                Прикрепить файл
                            </Button>
                        </Upload>
                    </Col>
                </Row>

                <div className="d-flex justify-content-end mt-4">
                    <Button color="gold" key={1} htmlType="submit">
                        Сохранить
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};

export default AddFileModal;
